import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import styles from './BadgeList.module.scss';
import ElementList from '../element-list/ElementList';

export const BadgeList = ({ items }: { items: string[] }): ReactElement => {
  return (
    <ElementList>
      {items.map((item: string, idx: number) => (
        <VdsBadgePill
          key={idx + 1}
          className={styles.badge}
          value={item}
          size="extra-small"
          statusColor="information"
        />
      ))}
    </ElementList>
  );
};

export default BadgeList;
